import FingerprintJS from '@fingerprintjs/fingerprintjs'

let cachedDeviceId: string | null = null

export const getDeviceFingerprint = async (): Promise<string> => {
  if (cachedDeviceId) return cachedDeviceId

  const fp = await FingerprintJS.load()
  const result = await fp.get()
  cachedDeviceId = result.visitorId
  return cachedDeviceId
}
